const config = {
  // baseURL : 'https://api.realcloud.uwss.kr/v1',
  // baseSignalR : 'https://api.realcloud.uwss.kr',

  // baseURL : 'http://localhost:5000/v1',
  // baseURL_v2 : 'http://localhost:5000/v2',
  // baseSignalR : 'http://localhost:5001',

  // baseURL : 'https://api.f1secaas.co.kr/v1',

  // baseURL_v2 : 'https://api.f1secaas.co.kr/v2',

  // baseSignalR : 'https://ws.f1secaas.co.kr',
  // baseURL_v2 : 'https://api.f1secaas.co.kr/v2',

  baseURL : 'https://api.idc.uwss.kr/v1',
  baseSignalR : 'https://ws.idc.uwss.kr',
  baseURL_v2 : 'https://api.idc.uwss.kr/v2',

  // baseSignalR : 'https://ws.uwss.kr',

  // baseURL : 'https://api.uwss.jp/v1',
  // baseSignalR : 'https://ws.uwss.jp',

  // baseURL : 'http://localhost:5001/v1',
  // baseSignalR : 'http://localhost:5001',
  // baseURL : 'https://api.azure.uwss.kr/v1',
  // baseSignalR : 'https://api.azure.uwss.kr',
  manual : "f1-uwss.en.front.manual.latest.pdf",
  version : "2023.04", // 해당 버전에서 분기됨
  wsfinder_version : '2022.07',
  webcastle_version : '2022.07.1',
  webcastle_version_mmdb : '2023.05',
}

export default config;
